import { useState } from "react";
import { toast } from "sonner";
import { Zap, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { NOTE_CATEGORIES, NOTE_VISIBILITY, categoryDefaultColour } from "@/data/notebookOptions";

export const QuickCapture = ({ onSave }) => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [category, setCategory] = useState("Idea");
  const [visibility, setVisibility] = useState("Both founders");
  const [tag, setTag] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!title.trim()) { toast.error("Give your note a title"); return; }
    setSaving(true);
    try {
      await onSave({ title: title.trim(), body: body.trim(), category, colour: categoryDefaultColour(category), visibility, tags: tag ? [tag.trim()] : [] });
      setTitle(""); setBody(""); setTag(""); setCategory("Idea"); setVisibility("Both founders");
    } finally { setSaving(false); }
  };

  return (
    <div data-testid="quick-capture" className="rounded-2xl border border-[#E7E2D4] bg-gradient-to-br from-[#FFFDF7] to-[#FBF6E9] p-4 shadow-sm">
      <div className="mb-3 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-[#E0A82E] text-white"><Zap size={16} /></span>
        <div>
          <p className="font-heading text-sm font-semibold text-[#0D1B2A]">Quick Note</p>
          <p className="text-[11px] text-[#8A8674]">Jot it down now — polish it later.</p>
        </div>
      </div>
      <div className="space-y-2.5">
        <Input data-testid="quick-note-title" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="What's on your mind?" className="border-[#E7E2D4] bg-white" />
        <Textarea data-testid="quick-note-body" value={body} onChange={(e) => setBody(e.target.value)} placeholder="A quick thought… (optional)" rows={2} className="resize-y border-[#E7E2D4] bg-white" />
        <div className="flex flex-wrap items-center gap-2">
          <Select value={category} onValueChange={setCategory}><SelectTrigger data-testid="quick-note-category" className="w-auto min-w-[130px] border-[#E7E2D4] bg-white"><SelectValue /></SelectTrigger><SelectContent>{NOTE_CATEGORIES.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}</SelectContent></Select>
          <Select value={visibility} onValueChange={setVisibility}><SelectTrigger data-testid="quick-note-visibility" className="w-auto min-w-[140px] border-[#E7E2D4] bg-white"><SelectValue /></SelectTrigger><SelectContent>{NOTE_VISIBILITY.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}</SelectContent></Select>
          <Input data-testid="quick-note-tag" value={tag} onChange={(e) => setTag(e.target.value)} placeholder="tag (optional)" className="w-32 border-[#E7E2D4] bg-white" />
          <Button data-testid="quick-note-save" onClick={save} disabled={saving} className="ml-auto rounded-full bg-[#0D1B2A] text-white hover:bg-[#1B2A3B]"><Plus size={15} /> Save note</Button>
        </div>
      </div>
    </div>
  );
};
